var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support-modal"},[_c('div',{staticClass:"background-overlay"}),_c('div',{staticClass:"box",attrs:{"id":"support-box"}},[_c('div',{staticClass:"content",attrs:{"id":"support-box-inner"}},[_c('secondary-button',{staticClass:"cancel",attrs:{"label":'Cancel',"clicked":_vm.cancel}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }